import { H_REFERENCIAL_UNIT_MANAGMENT } from 'account/constants/AccessRulesConstants'
import FixedSlideNav from 'components/navbar/FixedSlideNav'
import BoundaryError from 'log/components/BoundaryError'
import React, { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { Outlet, useParams } from 'react-router-dom'
import { REFERENCIAL_TYPE_NAME } from 'referencial/constants/ReferencialConstants'
import i18n from 'simple-react-i18n'
import { componentHasHabilitations } from 'utils/HabilitationUtil'
import ManagementUnitAction from '../actions/ManagementUnitAction'
import { Box } from '@mui/material'

const ManagementUnitRouterApp = () => {
    const dispatch = useDispatch()
    const { code } = useParams()

    const navLinks = useMemo(() => {
        return [{
            icons: 'dashboard',
            name: i18n.dashboard,
            href: `/referencial/${REFERENCIAL_TYPE_NAME.managementUnit}/${code}/dashboard`,
            habilitation: H_REFERENCIAL_UNIT_MANAGMENT,
        }].filter(l => componentHasHabilitations(l.habilitation))
    }, [code])

    useEffect(() => {
        dispatch(ManagementUnitAction.fetchManagementUnits())
        if (code !== 'new') {
            dispatch(ManagementUnitAction.fetchManagementUnit(code))
        }
    }, [dispatch, code])

    return (
        <Box>
            <FixedSlideNav links={navLinks} />
            <Box padding={1} className='content-page fullscreen'>
                <BoundaryError>
                    <Outlet />
                </BoundaryError>
            </Box>
        </Box>
    )
}

export default ManagementUnitRouterApp